import { render, staticRenderFns } from "./periodSelector.vue?vue&type=template&id=faafcbd8&"
import script from "./periodSelector.vue?vue&type=script&lang=ts&"
export * from "./periodSelector.vue?vue&type=script&lang=ts&"
import style0 from "./periodSelector.vue?vue&type=style&index=0&id=faafcbd8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports